import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import CustomerProfileAvatar from 'components/customer/summary/customer_profile_avatar';
import connect from 'components/lib/connect';
import Tooltip from 'components/common/tooltip';
import LinkedIcon from 'components/lib/icons/customer_linked_icon';
import OpenModal from 'actions/modal/open_modal';
import UnlinkProfile from 'models/modal/unlink_profile';
import { ExternalCustomerLookupStatusValue } from 'models/external_customer_lookup_status';

export function CustomerInformationAvatar({ name, systemName, showLinkedIcon, onClickCustomerUnlink }) {
  if (!showLinkedIcon) {
    return renderAvatar();
  }

  const message = (
    <StyledLinkedItemTooltip>
      {name} is linked to a customer on {systemName}. Unlink this customer if the information is wrong by clicking on
      the {renderLinkedIcon()} icon.
    </StyledLinkedItemTooltip>
  );

  return (
    <Tooltip message={message} position="right">
      <StyledAvatarContainer onClick={onClickCustomerUnlink}>
        {renderAvatar()}
        <StyledLinkedIconOffset />
      </StyledAvatarContainer>
    </Tooltip>
  );

  function renderAvatar() {
    return <CustomerProfileAvatar className="customerSummary-customerName-avatar" />;
  }

  function renderLinkedIcon() {
    return (
      <StyledLinkedIconSpan>
        <StyledLinkedIcon />
      </StyledLinkedIconSpan>
    );
  }
}

const StyledLinkedIconSpan = styled.span`
  vertical-align: text-top;
`;

const StyledLinkedItemTooltip = styled.div`
  max-width: 280px;
`;

const StyledAvatarContainer = styled.div`
  position: relative;
  cursor: pointer;
`;

const StyledLinkedIcon = styled(LinkedIcon)`
  width: 16px;
  height: 16px;
  background: ${p => p.theme.colors.purple400};
  border-radius: 50%;
  padding: 3px;
  cursor: pointer;
`;

const StyledLinkedIconOffset = styled(StyledLinkedIcon)`
  position: absolute;
  top: 24px;
  left: 24px;
`;

CustomerInformationAvatar.propTypes = {
  name: PropTypes.string,
  systemName: PropTypes.string,
  showLinkedIcon: PropTypes.bool,
  onClickCustomerUnlink: PropTypes.func,
};

export default connect(mapStateToProps, mapExecuteToProps)(CustomerInformationAvatar);

function mapStateToProps({ getProvider, isFeatureEnabled }) {
  const profile = getProvider('profile').get();
  const customerIsLinked = profile && (profile.externalCustomerId || !_.isEmpty(profile.externalCustomerIds));
  const lookupStatus = getProvider('externalCustomerLookupStatus').get();
  const lookupEnabled = lookupStatus && lookupStatus.status === ExternalCustomerLookupStatusValue.OK;

  const name = _.get(profile, 'name');
  const showLinkedIcon = customerIsLinked && lookupEnabled;

  return {
    name,
    systemName: _.get(lookupStatus, 'name'),
    showLinkedIcon,
  };
}

function mapExecuteToProps(executeAction, { customerId }) {
  return {
    onClickCustomerUnlink: () => executeAction(OpenModal, new UnlinkProfile({ customerId })),
  };
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/summary/customer_information_avatar.jsx